var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from "vue-property-decorator";
import { DecisionState } from "@/common/types/DecisionState";
import { ApprovingReason } from "@/common/types/ApprovingReason";
import { RejectionReason } from "@/common/types/RejectionReason";
import TextLabelRow from "@/common/components/TextLabelRow.vue";
import AidApplicationFeedbackBase from "./AidApplicationFeedbackBase";
var AidDecisionView = /** @class */ (function (_super) {
    __extends(AidDecisionView, _super);
    function AidDecisionView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AidDecisionView.prototype, "isApproved", {
        get: function () {
            return this.record.decisionState === DecisionState.Approved;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidDecisionView.prototype, "requestedAmountTitle", {
        get: function () {
            return (this.isGrantedAtOnceProject
                ? this.$t("Feedback.AidApplication.AidDecisionGrantedAtOnceProject.RequestedAmount")
                : this.$t("Feedback.AidApplication.RequestedAmount", { 0: this.record.year }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidDecisionView.prototype, "grantedAmountTitle", {
        get: function () {
            var resourcekey = this.isGrantedAtOnceProject
                ? "Feedback.AidApplication.AidDecisionGrantedAtOnceProject.GrantedAmount"
                : "Feedback.AidApplication.AidDecision.GrantedAmount";
            return this.$t(resourcekey, { 0: this.record.year });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidDecisionView.prototype, "approvingReason", {
        get: function () {
            return this.$i18n.t("Enums.ApprovingReason." + ApprovingReason[this.model.feedback.approvingReason]).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidDecisionView.prototype, "rejectionReason", {
        get: function () {
            return this.$i18n.t("Enums.RejectionReason." + RejectionReason[this.model.feedback.rejectionReason]).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AidDecisionView.prototype, "decisionDate", {
        get: function () {
            return this.$options.filters.formatDate(this.model.feedback.stmDecisionDate, true);
        },
        enumerable: false,
        configurable: true
    });
    AidDecisionView = __decorate([
        Component({
            name: "AidDecisionView",
            components: {
                TextLabelRow: TextLabelRow
            }
        })
    ], AidDecisionView);
    return AidDecisionView;
}(AidApplicationFeedbackBase));
export default AidDecisionView;
